import { DateField, TextField } from '@refinedev/antd';
import { useOne } from '@refinedev/core';
import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';

import LinkTextField from '@/components/general/LinkTextField';
import { ShowInfoGrid, ShowInfoItem } from '@/components/general/ShowInfo/ShowInfo';
import { ShowSection } from '@/components/general/ShowInfo/ShowSection';
import { COMPANY_URLS, TECHNICIAN_URLS } from '@/constants/urls';

interface ServiceOrderShowDetailProps {
  serviceOrder: any;
}

const ServiceOrderShowDetail = (props: ServiceOrderShowDetailProps) => {
  const { t } = useTranslation();
  const { serviceOrder } = props;
  const { result: contactData } = useOne({
    resource: COMPANY_URLS.GET_CONTACT.substring(1),
    id: serviceOrder.contact_data?.toString(),
  });

  return (
    <ShowSection title={t('Detalles de la orden de servicio')}>
      <ShowInfoGrid>
        <ShowInfoItem label={t('Técnico')}>
          <LinkTextField
            admin
            to={`${TECHNICIAN_URLS.ADMIN}/${serviceOrder.technician?.id}`}
            label={serviceOrder.technician?.nombre ?? '-'}
          />
        </ShowInfoItem>
        <ShowInfoItem label={t('Empresa')}>
          <LinkTextField
            admin
            to={`${COMPANY_URLS.ADMIN_EMPRESA}/${serviceOrder.company?.id}`}
            label={serviceOrder.company?.full_name ?? '-'}
          />
        </ShowInfoItem>
        {serviceOrder.company?.inscripcion_estadual && (
          <ShowInfoItem label={t('Inscripción estadual')}>
            <TextField value={serviceOrder.company?.inscripcion_estadual ?? '-'} />
          </ShowInfoItem>
        )}

        <ShowInfoItem label={t('Fecha del servicio')}>
          {serviceOrder.service_date ? (
            <DateField value={serviceOrder.service_date} format="LL" />
          ) : (
            '-'
          )}
        </ShowInfoItem>
        <ShowInfoItem label={t('Contacto de la empresa')}>
          <div>
            <Typography.Text type="secondary">Nombre: </Typography.Text>
            <TextField value={contactData?.name ?? '-'} />
          </div>
          <div>
            <Typography.Text type="secondary">Email: </Typography.Text>
            <TextField value={contactData?.email ?? '-'} />
          </div>
          <div>
            <Typography.Text type="secondary">Teléfono: </Typography.Text>
            <TextField value={contactData?.phone ?? '-'} />
          </div>
        </ShowInfoItem>
      </ShowInfoGrid>
    </ShowSection>
  );
};

export default ServiceOrderShowDetail;
